import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { CANCEL_ALL_TASKS_WS } from "./actionTypes";
import { cancelAllTasksWorkstationsSuccess, cancelAllTasksWorkstationsError } from "./actions";

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const workstationAPI = getWorkstationsAPI();

function* cancelAllTasksWorkstation({ payload: { ws, token, history } }) {

  try {
    console.log(token)
    const response = yield call(workstationAPI.cancelAllTasksWorkstation, ws, token);
    yield put(cancelAllTasksWorkstationsSuccess(response.message));
    history.go()
  } catch (error) {
    yield put(cancelAllTasksWorkstationsError(error));
  }
}

export function* watchCancelAllTasksWorkstations() {
  yield takeEvery(CANCEL_ALL_TASKS_WS, cancelAllTasksWorkstation);
}

function* CancelAllTasksWorkstationsSaga() {
  yield all([fork(watchCancelAllTasksWorkstations)]);
}

export default CancelAllTasksWorkstationsSaga;
